(function () {
  function initGalleryNav(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var prevBtn = viewer.querySelector('button[name="previous"]');
    var nextBtn = viewer.querySelector('button[name="next"]');
    if (!prevBtn || !nextBtn) return;

    function navigate(dir) {
      var items = Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));
      var activeIdx = items.findIndex(function (el) { return el.classList.contains('is-active'); });
      var curr = activeIdx === -1 ? 0 : activeIdx;
      var targetIdx = curr + dir;
      if (targetIdx < 0 || targetIdx >= items.length) return;
      gallery.setActiveMedia(items[targetIdx].dataset.mediaId, false);
    }

    // Capture phase fires before SliderComponent's bubble-phase listener
    prevBtn.addEventListener('click', function (e) { e.stopImmediatePropagation(); navigate(-1); }, true);
    nextBtn.addEventListener('click', function (e) { e.stopImmediatePropagation(); navigate(1); }, true);
  }

  customElements.whenDefined('media-gallery').then(function () {
    document.querySelectorAll('media-gallery').forEach(initGalleryNav);
  });
})();

// Sticky ATC bar
(function () {
  var bar = document.getElementById('sp-sticky-atc');
  if (!bar) return;

  var originalBtn = document.querySelector('button.product-form__submit');
  if (!originalBtn) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        bar.classList.remove('sp-sticky-atc--visible');
        bar.setAttribute('aria-hidden', 'true');
      } else {
        bar.classList.add('sp-sticky-atc--visible');
        bar.setAttribute('aria-hidden', 'false');
      }
    });
  }, { threshold: 0.1 });

  observer.observe(originalBtn);

  bar.querySelector('.sp-sticky-atc__btn').addEventListener('click', function () {
    originalBtn.click();
  });
})();
